import store from '@/store'
import { tkParse } from '@moke/vue-tk'

export default async () => {
  // 如果不是库级管理员，直接返回
  if (!store.getters.isWarehouseAdmin) {
    return
  }

  // 获取用户所属的层级标签
  const userLevelTag = store.getters.userLevelTag
  // 根据用户层级查询所属的粮库
  const res = await tkParse.get('/classes/grainWarehouse', {
    params: {
      where: {
        hierarchy: {
          $inQuery: {
            where: {
              tag: { $regex: '^' + userLevelTag }
            },
            className: 'hierarchy'
          }
        }
      },
      limit: 1
    }
  })
  // 如果找到了粮库，则保存到 store
  if (res.data.results.length > 0) {
    store.commit('setWarehouseId', res.data.results[0].objectId)
  }
}
